import './Configuration.scss';
import { Grid, GridItem, Heading, Space } from 'plume-ui';
import { HeadingStyles } from 'plume-ui/dist/components/Heading/Heading';
import React, { memo, useEffect } from 'react';
import { useFeaturePermission } from '../../../hooks/useFeaturePermission';
import { MixPanelEvents } from '../../../mixPanelEvents';
import { Permission } from '../../../userPermissionConfig';
import FormattedMessage from '../../../utils/components/FormattedMessage';
import { AdjustableComponent } from '../../../utils/hooks/useClasses';
import { useTrackEvent } from '../../trackingAnalytics/hooks/useTrackEvent';
import { AvailableScreens } from '../../trackingAnalytics/types';
import Emails from '../components/Emails/Emails';
import EmailModal from '../components/Emails/modal/EmailModal';
import InfoModal from '../components/InfoModal';
import IssueResolution from '../components/IssueResolution/IssueResolution';
import UrlModal from '../components/Urls/modal/UrlModal';
import Urls from '../components/Urls/Urls';
import WebhookModal from '../components/Webhook/modal/WebhookModal';
import Webhook from '../components/Webhook/Webhook';

type ConfigurationProps = {};

type ConfigurationStyles = {};

const Configuration: AdjustableComponent<
  ConfigurationProps,
  ConfigurationStyles
> = () => {
  const trackEvent = useTrackEvent();
  const { hasPermission } = useFeaturePermission();
  const canEditConfigurationContent = hasPermission(
    Permission.ModifyConfiguration,
  );

  useEffect(() => {
    trackEvent({
      eventName: MixPanelEvents.SCREEN,
      additionalContent: {
        SCREEN: AvailableScreens.Configuration,
      },
    });
  }, []);

  return (
    <div className="Configuration">
      <Grid>
        <GridItem colSpan="12" tabletColSpan="12">
          <Space size="l" />
          <Heading
            classes={(current: HeadingStyles) => ({
              root: `${current.root} AppLayout__header`,
            })}
            size="xxxxl"
            medium
          >
            <FormattedMessage id="configuration.title" />
          </Heading>
          <Space size="s" />
        </GridItem>
        <IssueResolution editAllowed={true} />
        <Webhook editAllowed={canEditConfigurationContent} />
        <Urls editAllowed={canEditConfigurationContent} />
        <Emails editAllowed={canEditConfigurationContent} />
      </Grid>
      <WebhookModal />
      <UrlModal />
      <EmailModal />
      <InfoModal />
    </div>
  );
};

export default memo(Configuration);
